import classes from "./RoomVertical.module.css"
import arr1 from "../../../../store/arrow.png";
import logo from "../../../../store/logo.png";
import {useEffect, useState} from "react";
import axios from "axios";
import { path, assetsBaseUrl } from "../../../../routes";

const RoomVertical = (props) => {
    const [actTime, setactTime] = useState("undefined");
    const [actDate, setactDate] = useState("undefined");

    const [loadedSlides, setloadedSlides] = useState(props.object.object);
    const [loadedSlidesDefault, setloadedSlidesDefault] = useState(props.default);
    const [meetingA, setMeetingA] = useState([]);
    const [meetingB, setMeetingB] = useState([]);
    const [meetingC, setMeetingC] = useState([]);
    const [meetingD, setMeetingD] = useState([]);


    const getTime = () => {
        const now = new Date();

        // Získání jednotlivých částí data
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Měsíce jsou indexovány od 0
        const day = String(now.getDate()).padStart(2, '0');

        // Získání jednotlivých částí času
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        // Sestavení výsledného řetězce
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }

    const sort_handler = (field) => {
        setMeetingA([])
        setMeetingB([])
        setMeetingC([])
        setMeetingD([])
        for (let i = 0; i < field.length; i++) {
            let tmp = field[i].description.substring(13)
            if (tmp == "A") {
                setMeetingA([assetsBaseUrl + field[i].path])
                //console.warn("Setting new A")
            }
            if (tmp == "B") {
                setMeetingB([assetsBaseUrl + field[i].path])
                //console.warn("Setting new B")
            }
            if (tmp == "C") {
                setMeetingC([assetsBaseUrl + field[i].path])
                //console.warn("Setting new C")
            }
            if (tmp == "D") {
                setMeetingD([assetsBaseUrl + field[i].path])
                //console.warn("Setting new D")
            }
        }
    }

    useEffect(() => {
        sort_handler(props.object.object)

        const getDefaultSlides = async () => {
            let tmpA = []
            let response = await axios.get(`${path}/getDefaultScreen`);
            //console.log(response.data)
            for (let i = 0; i < response.data.length; i++) {
                tmpA.push(assetsBaseUrl + response.data[i].path)
            }
            //console.log(tmpA)
            setloadedSlidesDefault([...tmpA])
        }

        const getRecords = async () => {
            //console.warn(def)
            await getDefaultSlides()
            try {
                let response
                response = await axios.get(`${path}/getMeeting2/${encodeURIComponent(getTime())}`);
                if (response.data.length > 0) {
                    let p = []

                    setloadedSlides(response.data)
                    sort_handler(response.data)
                } else {
                    setloadedSlides([])
                    setMeetingA([])
                    setMeetingB([])
                    setMeetingC([])
                    setMeetingD([])
                }

            } catch (error) {

            }
        }

        const updateMinute = () => {
            let dt = new Date
            //console.log(dt)
            setactTime(`${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`)
            setactDate(`${String(dt.getDate()).padStart(2, "0")}. ${String(dt.getMonth() + 1).padStart(2, "0")}. ${dt.getFullYear()}`)
        };

        // Nastavení intervalu pro reload meeting dat (dřív 60 s)
        const intervalId = setInterval(updateMinute, 1000);
        const intervalUpdate = setInterval(getRecords, 20 * 1000);
        // Cleanup funkce, která se spustí při unmountu komponenty
        return () => {
            clearInterval(intervalId);
            clearInterval(intervalUpdate);
        };
    }, []);
    useEffect(() => {
        const resetVal = async () =>{
            let rs = await axios.post(`${path}/updateReset/30`)
        }

        const getReset = async () =>{
            try {
                let response = await axios.get(`${path}/getReset/30`);
                console.log(response.data[0].needUpdate);
                if (response.data[0].needUpdate === 1)
                {
                    // console.log("update")
                    resetVal()
                    console.log(`FE_refresh needed: ${response.data[0].needUpdate === 1? "YES":"NO"}`)
                    window.location.reload();

                }
                else {
                    //setneedUpdate(0)
                    console.log(`FE_refresh needed: ${response.data[0].needUpdate === 1? "YES":"NO"}`)
                }
            }
            catch (error){

            }
        }
        const intervalId5 = setInterval(getReset, 60 * 2 * 1000);
        return () => {
            clearInterval(intervalId5);
        };
    }, []);

    let roomA = <div className={classes.mainbox}>
        <div className={classes.arrowbox}>
            <img className={classes.left} src={arr1} alt="logo"/>
            <div className={classes.bigChar}>A</div>
            <div>{`Konferenční místnost / Meeting room `}</div>

        </div>
        <div className={classes.logobox}>
            <img src={meetingA[0]} alt="logo"/>
        </div>
    </div>
    let roomB = <div className={classes.mainbox}>
        <div className={classes.arrowbox}>
            <img className={classes.left} src={arr1} alt="logo"/>
            <div className={classes.bigChar}>B</div>
            <div>{`Konferenční místnost / Meeting room `}</div>
        </div>
        <div className={classes.logobox}>
            <img src={meetingB[0]} alt="logo"/>
        </div>
    </div>
    let roomC = <div className={classes.mainbox}>
        <div className={classes.arrowbox}>
            <img className={classes.left} src={arr1} alt="logo"/>
            <div className={classes.bigChar}>C</div>
            <div>{`Konferenční místnost / Meeting room `}</div>
        </div>
        <div className={classes.logobox}>
            <img src={meetingC[0]} alt="logo"/>
        </div>
    </div>
    let roomD = <div className={classes.mainbox}>
        <div className={classes.arrowbox}>
            <img className={classes.left} src={arr1} alt="logo"/>
            <div className={classes.bigChar}>D</div>
            <div>{`Konferenční místnost / Meeting room `}</div>
        </div>
        <div className={classes.logobox}>
            <img src={meetingD[0]} alt="logo"/>
        </div>
    </div>
    let def = <div className={classes.def}>
        <img src={loadedSlidesDefault[0]} alt={"logo"}/>
    </div>


    const hasMeeting = meetingA.length > 0 || meetingB.length > 0 || meetingC.length > 0 || meetingD.length > 0;
    return <div className={classes.slideTot}>
        <div className={classes.header}>
            <div className={classes.time}>
                <div className={classes.timeA}>{actTime}</div>
                <div className={classes.lineT}></div>
                <div className={classes.timeB}>{actDate}</div>
            </div>
        </div>
        {meetingA.length != 0 && roomA}
        {meetingA.length != 0 && <hr className={classes.line}/>}
        {meetingB.length != 0 && roomB}
        {meetingB.length != 0 && <hr className={classes.line}/>}
        {meetingC.length != 0 && roomC}
        {meetingC.length != 0 && <hr className={classes.line}/>}
        {meetingD.length != 0 && roomD}
        {meetingD.length == 0 && meetingC.length == 0 && meetingB.length == 0 && meetingA.length == 0 ? def:null}
    </div>
}

export default RoomVertical